import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getProjectByProjectName = (
    token: string,
    backend: string,
    projectName: string,
) => {
    return fetch(
        `${getApiUrl(backend)}projects/by_projectname/${projectName}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain, */*'
            },
        }
    );
};

export default getProjectByProjectName;